module.exports = __webpack_public_path__ + "static/media/item_32_4.db7e033e.png";